import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUsCarousel } from '../components/WhyUsCarousel';
import { Quiz } from '../components/Quiz';
import { Calculator } from '../components/Calculator';
import { Pricing } from '../components/Pricing';
import { Reviews } from '../components/Reviews';
import { GoogleReviews } from '../components/GoogleReviews';
import { Team } from '../components/Team';
import { HowAustriaWorks } from '../components/HowAustriaWorks';
import { Workflow } from '../components/Workflow';
import { useLanguage } from '../contexts/LanguageContext';
import { useSeoHead } from '../hooks/useSeoHead';
import { getRoutePair, hreflangFor, SITE_URL } from '../seoRoutes';
import { buildHomeJsonLd } from '../homeJsonLd';

const HOME = getRoutePair('home');

// Old client testimonials (t.reviews.items, components/Reviews.tsx) are switched off in
// favour of the Google reviews. Set to true to show them again instead.
const SHOW_LEGACY_TESTIMONIALS = false;

export const Home = () => {
  const { language } = useLanguage();
  const copy = language === 'EN' ? HOME.en : HOME.de;
  useSeoHead({
    title: copy.title,
    description: copy.description,
    canonical: `${SITE_URL}${copy.path}`,
    indexable: HOME.indexable,
    htmlLang: language === 'EN' ? 'en' : 'de',
    hreflang: hreflangFor(HOME),
    jsonLd: buildHomeJsonLd(language),
  });

  return (
    <>
      <Hero />
      <WhyUsCarousel />

      {SHOW_LEGACY_TESTIMONIALS ? <Reviews /> : <GoogleReviews />}

      <Quiz />

      <Pricing />

      <Workflow />

      <Team />

      <Calculator />

      <HowAustriaWorks />
    </>
  );
};
